
import React from 'react';
import { Link } from 'react-router-dom'
import { connect } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter, Tooltip,Button, Collapse } from 'reactstrap';


import Navbar from '../../../../../../_components/common/Navbar';
import SideNavBar from '../../../../../../_components/common/SideNavBar';
import ModalComponent from '../../../../../../_components/common/Modal';
import AnalysisNavBar from '../../../../../../_components/common/AnalysisNavBar';

import Swal from 'sweetalert2';
// import 'sweetalert2/src/sweetalert2.scss'

import './index.css'
import { saveModulePermissionsAction, orgAdminAction, VirtualTeamAction, superAdminAction } from '../../../../../../_actions';
import { analyseActions } from '../../../../../../_actions';
import { AnalyzeAction } from '../../../../../../_actions/Analyze/analyze.action'
import { competencyListAction } from '../../../../../../_actions/Analyze/competencyList.action'

import _ from 'lodash';


class ManageTeams extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            SaveTeamState: false,
            disableSaveTeam: true,
            nameChecked: false,
            navData: [],
            VirtualTeamSidebarNav: {
                sideNavCatagoryData: [
                    {
                        name: 'Virtual Teams',
                        link: 'my-teams/manage-virtual-teams'
                    },
                    {
                        name: 'Virtual Team Members',
                        link: 'my-teams/virtual-teams/manage-members'
                    },
                    {
                        name: 'Share Virtual Teams',
                        link: 'my-teams/virtual-teams/manage-share'
                    },
                ]
            },
            teams: [],
            name: '',
            isCreatTrue: false,
            editTeamState: false,
            removeTeamState: false,
            teamDetails: '',
            teamlist_data: [],
            filterData: null,

            FilterForm: [],
            openFilterModal: false,
            footerNonSubmitButton: [{
                'buttonName': 'Apply Filters'
            }, {
                'buttonName': 'Remove All Filters'
            }, {
                'buttonName': 'Cancel'
            }],

            analyzeFilterData: {
                team_members: []
            },
            competencyList: [],
            competencyTriggered: false,

            sortedTeamMemberArr: [],
            filterBool: false,
        }
    }

    filterStateAnalyze = () => {
        const {analyzeFilterData} = this.state;
        if(analyzeFilterData) {
            if(analyzeFilterData !== null) {
                // if(this.props.filter_form_updated === false) {
                    
                // }else {

                //     let notFiltered = false
                //     let countOfFilteredObj = 0

                //     this.state.analyzeFilterData.team_members.map(val => {
                //         if(val.filtered !== undefined) {
                //             if(val.filtered === true){
                //                 countOfFilteredObj++
                //             }
                //         }else {
                //             notFiltered = true
                //         }
                //     })
    
                //     if(notFiltered && countOfFilteredObj === 0) {
                //         countOfFilteredObj = this.state.analyzeFilterData.team_members.length
                //     }
                //     this.setState({
                //         FilterForm: this.props.FilterForm_reducer,
                //         countOfFilteredObj,
                //     })
                // }
                let family_type_obj = {
                    mainLabel: 'Family Type:',
                    category: 'personal',
                    type: 'checkbox',
                    data: []
                }
    
                let city_obj = {
                    mainLabel: 'City:',
                    category: 'personal',
                    type: 'checkbox',
                    data: []
                }
    
                let country_obj = {
                    mainLabel: 'Country:',
                    category: 'personal',
                    type: 'checkbox',
                    data: []
                }
    
                let occupation_obj = {
                    mainLabel: 'Occupation:',
                    category: 'work',
                    type: 'checkbox',
                    data: []
                }
    
                let designation_obj =  {
                    mainLabel: 'Designation:',
                    category: 'work',
                    type: 'checkbox',
                    data: []
                }
    
                let qualification_obj = {
                    mainLabel: 'Qualification:',
                    category: 'work',
                    type: 'checkbox',
                    data: []
                }
    
                let industry_obj = {
                    mainLabel: 'Industry:',
                    category: 'work',
                    type: 'checkbox',
                    data: []
                }

                let gender_obj = {
                    mainLabel: 'Gender:',
                    type: 'checkbox',
                    category: 'personal',
                    data: []
                }

                

                let competency_obj = {
                    mainLabel: 'Rank by Competency',
                    category: 'competency',
                    type: 'checkbox',
                    data: []
                }
    
                //family type
                let family_type_different_types = []
                let uniqueArray_family_type = []
    
                //city
                let city_different_types = []
                let uniqueArray_city = []
    
                //country
                let country_different_types = []
                let uniqueArray_country = []
    
                //occupation
                let occupation_different_types = []
                let uniqueArray_occupation = []
    
                //designation
                let designation_different_types = []
                let uniqueArray_designation = []
    
                //qualifiation
                let qualifiation_different_types = []
                let uniqueArray_qualification = []
    
                //industry
                let industry_different_types = []
                let uniqueArray_industry = []

                //gender
                let gender_different_types = []
                let uniqueArray_gender = []

                //non dynamic formdata INPUT
                let FilterForm = [...this.state.FilterForm];
                

                FilterForm.push({
                    mainLabel: 'Age:',
                    type: 'number',
                    category: 'personal',
                    data: [{
                        key: 'age_between',
                        value: '',
                        name: 'age_between',
                        label: 'Between',
                        dataFilter: 'age'
                    }, {
                        key: 'age_and',
                        value: '',
                        name: 'age_and',
                        label: 'and',
                        dataFilter: 'age'            
                    }],
                })

                

                FilterForm.push({
                    mainLabel: 'No of Children:',
                    type: 'number',
                    category: 'personal',
                    data: [{
                        key: 'No of Children_between',
                        value: '',
                        name: 'No of Children_between',
                        label: 'Between',
                        dataFilter: 'no_of_children'
                    }, {
                        key: 'No of Children_and',
                        value: '',
                        name: 'No of Children_and',
                        label: 'and',
                        dataFilter: 'no_of_children'            
                    }],
                })

                FilterForm.push(gender_obj)

                FilterForm.push({
                    mainLabel: 'Marital status:',
                    category: 'personal',
                    type: 'checkbox',
                    data: []
                })

                

                

                let maritalCounter = {
                    counter: 0,
                    radio: []
                }
                let annualIncome = 0
                let work_experience = 0
                let tenure_in_company = 0
                let no_of_children = 0
                let age = 0
    
                analyzeFilterData.team_members.map(val => {

                    if(val.age !== 'Not specified') {
                        age++
                    }

                    //marital status
                    if(val.marital_status !== 'Not specified' && val.marital_status !== '') {
                        maritalCounter.counter++
                        maritalCounter.radio.push(val.marital_status)
                    }

                    //no_of_children
                    if(val.no_of_children !== 'Not specified' && val.no_of_children !== '') {
                        no_of_children++
                    }
                    //tenure_in_company
                    if(val.tenure_in_company !== 'Not specified' && val.tenure_in_company !== 0) {
                        tenure_in_company++
                    }
                    
                    //annual_income
                    if(val.annual_income !== 'Not specified' && val.annual_income !== '') {
                        annualIncome++
                    }
                    //work_experience
                    if(val.work_experience !== 'Not specified' && val.work_experience !== 0) {
                        work_experience++
                    }
                    

                    //family type
                    family_type_different_types.push(val.family_type)
                    
    
                    //city
                    city_different_types.push(val.city)
                    
    
                    //country
                    country_different_types.push(val.participant__country__country_name)
    
                    //occupation
                    if(val.occupation === '' || val.occupation === undefined) {
                        occupation_different_types.push("Not specified")
                    }else {
                        occupation_different_types.push(val.occupation)                            
                    }
                    
    
                    //designation
                    if(val.designation === '') {
                        designation_different_types.push("Not specified")
                    }else {
                        designation_different_types.push(val.designation)
                    }
                    
    
                    //qualification
                    if(val.qualification__demographic_name === '') {
                        qualifiation_different_types.push("Not specified")
                    }else {
                        qualifiation_different_types.push(val.qualification__demographic_name)
                    }
    
                    //industry
                    if(val.industry__demographic_name === ''){
                        industry_different_types.push("Not specified")
                    }else {
                        industry_different_types.push(val.industry__demographic_name)
                    }

                    //gender
                    if(val.participant__gender === '') {
                        gender_different_types.push("Not specified")
                    }else {
                        gender_different_types.push(val.participant__gender)                            
                    }
                    
    
                })

                if(tenure_in_company) {
                    FilterForm.push({
                        mainLabel: 'Tenure in company:',
                        type: 'number',
                        category: 'work',
                        data: [{
                            key: 'Tenure in company_between',
                            value: '',
                            name: 'Tenure in company_between',
                            label: 'Between',
                            dataFilter: 'tenure_in_company'
                        }, {
                            key: 'Tenure in company_and',
                            value: '',
                            name: 'Tenure in company_and',
                            label: 'and',
                            dataFilter: 'tenure_in_company'            
                        }],
                    })
                }

                if(work_experience) {
                    FilterForm.push({
                        mainLabel: 'Work Experience:',
                        type: 'number',
                        category: 'work',
                        data: [{
                            key: 'Work Experience_between',
                            value: '',
                            name: 'Work Experience_between',
                            label: 'Between',
                            dataFilter: 'work_experience'            
                        }, {
                            key: 'Work Experience_and',
                            value: '',
                            name: 'Work Experience_and',
                            label: 'and',
                            dataFilter: 'work_experience'            
                        }],
                    })
                }

                if(annualIncome) {
                    FilterForm.push({
                        mainLabel: 'Annual income:',
                        type: 'checkbox',
                        category: 'work',
                        data: [
                            {
                                key: 'Annual income',
                                value: false,
                                name: 'Annual income',
                                label: '< $100,000',
                                dataFilter: 'annual_income',
                                data: {
                                    min: 0,
                                    max: 99999
                                }
                            }, {
                                key: 'Annual income',
                                value: false,
                                name: 'Annual income',
                                label: '$100,000 - $250,000',
                                dataFilter: 'annual_income',
                                data: {
                                    min: 100000,
                                    max: 249000
                                }
                            }, {
                                key: 'Annual income',
                                value: false,
                                name: 'Annual income',
                                label: '> $250,000',
                                dataFilter: 'annual_income',
                                data: {
                                    min: 250000,
                                    max: Infinity
                                }
                            }
                        ]
                    })
                }

                function removeObjectFromArr(stringToMatch) {
                    let pos = 0
                    FilterForm.map((val, key) => {
                        if(val.mainLabel === stringToMatch) {
                            pos = key
                        }
                    })
                    if(pos) {
                        FilterForm.splice(pos, 1)
                    }
                }
                if(maritalCounter.counter) {
                    let pos = 0
                    FilterForm.map((val, key) => {
                        if(val.mainLabel === 'Marital status:') {
                            pos = key
                        }
                    })
                    if(pos) {
                        const uniqueArray_marital_status = maritalCounter.radio.filter(function(item, position) {
                            return maritalCounter.radio.indexOf(item) == position;
                        })
                        uniqueArray_marital_status.map(val => {
                            FilterForm[pos].data.push({
                                key: 'Marital status',
                                value: false,
                                name: 'Marital status',
                                label: val,
                                dataFilter: 'marital_status'
                            })
                        })
                    }
                }else {
                    removeObjectFromArr('Marital status:')
                }

                if(!no_of_children) {
                    removeObjectFromArr('No of Children:')
                }

                if(!age) {
                    removeObjectFromArr('Age:')
                }

                if(!maritalCounter.counter && !no_of_children && !age) {
                    FilterForm.splice(0, 1)
                }

                
    
                //family type
                uniqueArray_family_type = family_type_different_types.filter(function(item, pos) {
                    return family_type_different_types.indexOf(item) == pos;
                })
                uniqueArray_family_type.map(val => {
                    family_type_obj.data.push({
                        key: 'Family Type',
                        value: false,
                        name: 'Family Type',
                        label: val,
                        dataFilter: 'family_type',
                    })
                })
                FilterForm.push(family_type_obj)
    
                //city
                uniqueArray_city = city_different_types.filter(function(item, pos) {
                    return city_different_types.indexOf(item) == pos;
                })
    
                uniqueArray_city.map(val => {
                    city_obj.data.push({
                        key: 'city',
                        value: false,
                        name: 'city',
                        label: val,
                        dataFilter: 'city'
                    })
                })
                FilterForm.push(city_obj)
    
                //country
                uniqueArray_country = country_different_types.filter(function(item, pos) {
                    return country_different_types.indexOf(item) == pos;
                })
    
                uniqueArray_country.map(val => {
                    country_obj.data.push({
                        key: 'country',
                        value: false,
                        name: 'country',
                        label: val,
                        dataFilter: 'user__country__country_name'
                    })
                })
                FilterForm.push(country_obj)
    
                //occupation
                uniqueArray_occupation = occupation_different_types.filter(function(item, pos) {
                    return occupation_different_types.indexOf(item) == pos;
                })
    
                uniqueArray_occupation.map(val => {
                    occupation_obj.data.push({
                        key: 'occupation',
                        value: false,
                        name: 'occupation',
                        label: val,
                        dataFilter: 'occupation'
                    })
                })
                FilterForm.push(occupation_obj)
                
                //designation
                uniqueArray_designation = designation_different_types.filter(function(item, pos) {
                    return designation_different_types.indexOf(item) == pos;
                })
    
                uniqueArray_designation.map(val => {
                    designation_obj.data.push({
                        key: 'Designation',
                        value: false,
                        name: 'Designation',
                        label: val,
                        dataFilter: 'designation'                
                    })
                })
                FilterForm.push(designation_obj)
    
                //qualification
                uniqueArray_qualification = qualifiation_different_types.filter(function(item, pos) {
                    return qualifiation_different_types.indexOf(item) == pos;
                })
    
                uniqueArray_qualification.map(val => {
                    qualification_obj.data.push({
                        key: 'Qualification',
                        value: false,
                        name: 'Qualification',
                        label: val,
                        dataFilter: 'qualification__demographic_name'                
                    })
                })
                FilterForm.push(qualification_obj)
    
                //designation
                uniqueArray_industry = industry_different_types.filter(function(item, pos) {
                    return industry_different_types.indexOf(item) == pos;
                })
    
                uniqueArray_industry.map(val => {
                    industry_obj.data.push({
                        key: 'industry',
                        value: false,
                        name: 'industry',
                        label: val,
                        dataFilter: 'industry__demographic_name'
                    })
                })
                FilterForm.push(industry_obj)

                uniqueArray_gender = gender_different_types.filter(function(item, pos) {
                    return gender_different_types.indexOf(item) == pos;
                })
    
                uniqueArray_gender.map(val => {
                    gender_obj.data.push({
                        key: 'participant__gender',
                        value: false,
                        name: 'participant__gender',
                        label: val,
                        dataFilter: 'participant__gender'
                    })
                })

                FilterForm.map((val, key) => {
                    if(val.mainLabel === 'Gender:') {
                        val.data = gender_obj.data
                    }
                })


                this.state.competencyList.map(competency => {
                    // if(competency.competency_type === "Competency") {
                        competency_obj.data.push({
                            key: 'competency',
                            value: false,
                            name: 'competency',
                            label: competency.competency_metric__competency_name ? competency.competency_metric__competency_name : competency.assessment_organisation_competency__competency_name,
                            id: competency.id,
                            dataFilter: 'competency_name'
                        })
                    // }
                })
                FilterForm.push(competency_obj)
    
                
                let notFiltered = false
                let countOfFilteredObj = 0
                this.state.analyzeFilterData.team_members.map(val => {
                    if(val.filtered !== undefined) {
                        if(val.filtered === true){
                            countOfFilteredObj++
                        }
                    }else {
                        notFiltered = true
                    }
                })

                if(notFiltered && countOfFilteredObj === 0) {
                    countOfFilteredObj = this.state.analyzeFilterData.team_members.length
                }
                
                this.setState({
                    FilterForm,
                    analyzeDataFilterData: this.state.analyzeFilterData,
                    countOfFilteredObj
                }, () => {
                    // const {dispatch} = this.props;
                    // dispatch({
                    //     type: 'ADD_FILTER_FORM',
                    //     payload: this.state.FilterForm,
                    //     filter_used: 'No Filters Applied'
                    // })
                })
            }
        }
    }

    componentDidUpdate(prevProp, prevState) {
        if(prevState.FilterForm !== this.state.FilterForm) {
            this.state.FilterForm.map(val => {
                // let competency_obj = {
                //     mainLabel: 'Rank by Competency',
                //     type: 'radio',
                //     data: []
                // }
                if(val.mainLabel) {
                    if(val.mainLabel === 'Rank by Competency') {
                        val.data.map(ob => {
                            if(ob.value) {
                                this.setState({
                                    competencyTriggered: true
                                })
                            }
                        })
                    }
                }
            })
        }

        if(prevProp.saveAssesorGroupListResponse !== this.props.saveAssesorGroupListResponse) {
            if(this.props.saveAssesorGroupListResponse !== '') {
                this.setState({filterData: this.props.saveAssesorGroupListResponse})
            }
        }
        if(prevProp.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
            if(this.props.headPerLoadingResonse !== '') {
                const temp = []
                if(localStorage.getItem("is_pa_user") == "true") {
                    temp.push({
                        navName: "Analyze",
                        link: `/organisation/${this.props.match.params.id}/user`
                    })
                }
                if(localStorage.getItem("is_org_admin") == "true") {
                    temp.push({
                        navName: "Org Admin Area",
                        link: `/organisation/${this.props.match.params.id}/org-admin`
                    })
                }
                if(localStorage.getItem("is_success") == "true") {
                    temp.push({
                        navName: "Super Admin Area",
                        link: `/organisation/${this.props.match.params.id}/super-admin`
                    })
                }
                this.setState({navData: temp})
            }
        }
    }

    componentDidMount() {

        //filter data
        if(this.props.saveAssesorGroupListResponse !== '') {
            this.setState({filterData: this.props.saveAssesorGroupListResponse},() => {
            })
        }

        this.props.dispatch(saveModulePermissionsAction.requestModulePermissionsHandler())
        if (this.props.saveModulePermissionsResponse === '' || (+this.props.saveTeamDetailsResponse.orgId !== +this.props.match.params.id)) {
            const fd = {
                "pa_user_email": localStorage.getItem('user_email'),
                "organisation_id": +this.props.match.params.id
            }
            this.props.dispatch(orgAdminAction.getModulePermissionListHandler(fd, () => {
                this.props.dispatch(saveModulePermissionsAction.saveModulePermissionsHandler(this.props.getModulePermissionsListResponse))
                this.props.dispatch(saveModulePermissionsAction.requestModulePermissionsHandler())
            }))
        }
        else {
            this.props.saveModulePermissionsResponse.filter(
                (data, i) => {
                    if (data.module_list__module_name === 'Virtual Teams') {
                        return data
                    }
                }
            ).length === 0 &&
                this.props.history.push(`/organisation/${this.props.match.params.id}/user/dashboard`)
        }

        const temp = []
        if(localStorage.getItem("is_pa_user") == "true") {
            temp.push({
                navName: "Analyze",
                link: `/organisation/${this.props.match.params.id}/user`
            })
        }
        if(localStorage.getItem("is_org_admin") == "true") {
            temp.push({
                navName: "Org Admin Area",
                link: `/organisation/${this.props.match.params.id}/org-admin`
            })
        }
        if(localStorage.getItem("is_success") == "true") {
            temp.push({
                navName: "Super Admin Area",
                link: `/organisation/${this.props.match.params.id}/super-admin`
            })
        }
        this.setState({navData: temp})

        //list api trigger here
        const {dispatch} = this.props;

        const data = {
			"analytics_org_id":+this.props.match.params.id
        }

        dispatch(VirtualTeamAction.listApi(data, (listApi_data) => {

            let teams_list = [...listApi_data.data.members.order_by_name];
            let teams = [];
            teams_list.map(val => {
                let obj = {
                    id: val.participant__id,
                    mainId: val.id,
                    name: val.participant__full_name ? val.participant__full_name : val.participant__email,
                    // members: 6,
                    link: `/organisation/${this.props.match.params.id}/my-teams/virtual-teams/manage-members/${val.id}`,
                    is_team_leader: false,
                    selected: false,
                }
                teams.push(obj)
            })
            
            this.setState({
                teams,
                analyzeFilterData: {
                    team_members: teams_list
                }
            }, () => {
                this.props.dispatch(superAdminAction.getAnalyticsMetricListHandler({ "analytics_organisation": +this.props.match.params.id }, (competencyList) => {
                    this.setState({
                        competencyList: competencyList.data.organisation_competency_metrics.filter(metric => metric.assessment_organisation_competency__competency_type__competency_name === "Competency").concat(competencyList.data.default_competency_metrics.filter(metric => metric.competency_metric__competency_type__competency_name === "Competency"))
                    }, () => {
                        this.filterStateAnalyze()
                    })
                }, 'complist'))
            })
        }))
        
        dispatch(VirtualTeamAction.virtualListApi(data, (teamlist_data) => {
            this.setState({
                teamlist_data: teamlist_data.data.team
            })
        }))
    }

    actionSelected(data) {
        const { dispatch } = this.props;

        const postObj_edit = { 
            "team_id":this.state.teamDetails.id, 
            "team_name":data.data.team_name 
        }

        const postObj_list = {
			"analytics_org_id":+this.props.match.params.id
        }

        

        dispatch(VirtualTeamAction.editApi(postObj_edit, (editApiData) => {
            Swal({
                text: editApiData.data.message,
                type: 'success',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'OK'
            })
            dispatch(VirtualTeamAction.virtualListApi(postObj_list, (teamlist_data) => {
                this.setState({
                    teamlist_data: teamlist_data.data.team
                })
            }))
        }))
    }


    toggleEntireTeamModal(showModal) {
        this.setState({
            editTeamState: showModal,
            removeTeamState: showModal,
        })
    }

    onClickResponseHandler = (data) => {
        if(data === 'Remove') {
            let team_id = this.state.teamDetails.id
            const {dispatch} = this.props;

            let postObj = {
                data: {
                    team_id
                }
            }

            let postObj_teamList = {
                "analytics_org_id":+this.props.match.params.id
            }

            dispatch(VirtualTeamAction.deleteTeamName(postObj,(dataFromApi) => {
                Swal({
                    text: dataFromApi.data.message,
                    type: 'success',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'OK'
                })
                dispatch(VirtualTeamAction.virtualListApi(postObj_teamList, (reloaded) => {
                    this.setState({
                        teamlist_data: reloaded.data.team
                    })
                }))
            }))
        }
        this.setState({
            removeTeamState: false,
        })
    }

    onClickSaveTeamHandler = (data) => {

        const {dispatch} = this.props;

        let isCreatTrue = false;
        if(data === 'Cancel') {
            this.setState({
                isCreatTrue,
                SaveTeamState: false,                
            })
        }else if(data === 'Add') {
            let selectedTeams = [];
            let teamLeader = 0;
            let teams = [...this.state.teams];

            teams.map(val => {
                if(val.selected) {
                    selectedTeams.push(val.id)
                }
                if(val.is_team_leader) {
                    teamLeader = val.id
                }
            })

            let obj = {
                "organisation":+this.props.match.params.id,
                "team_name":this.state.name,
                "team_member_id":selectedTeams,
                "team_leader_id":teamLeader
            }

            dispatch(VirtualTeamAction.createApi(obj, (create_list_teams, error) => {
                if(error) {
                    if(create_list_teams["response"]["data"].message !== undefined) {
                        Swal({
                            text: create_list_teams["response"]["data"].message,
                            type: 'error',
                            confirmButtonColor: '#3085d6',
                            confirmButtonText: 'OK'
                        })
                        isCreatTrue = true
                    }
                }else {
                    if(create_list_teams.data.error_message.length === 0) {
                        Swal({
                            text: create_list_teams.data.message,
                            type: 'success',
                            confirmButtonColor: '#3085d6',
                            confirmButtonText: 'OK'
                        })
                    }else {
                        let text = ''
                        create_list_teams.data.error_message.map(val => {
                            text = `${text} <p>${val.email} : ${val.message}</p>`
                        })
                        text = `${text} <p>${create_list_teams.data.message}</p>`
                        Swal({
                            html: text,
                            type: 'error',
                            confirmButtonColor: '#3085d6',
                            confirmButtonText: 'OK'
                        })
                    }
                }


                this.setState({
                    SaveTeamState: false,
                    isCreatTrue
                }, () => {
                    if(isCreatTrue === false) {

                        let postObj_teamList = {
                            "analytics_org_id":+this.props.match.params.id
                        }

                        dispatch(VirtualTeamAction.virtualListApi(postObj_teamList, (reloaded) => {
                            this.setState({
                                teamlist_data: reloaded.data.team
                            })
                        }))
                    }
                })

            }))
        }
    }

    onCheckSaveTeam = (teams, name) => {
        // disableSaveTeam

        let checkedCount = 0;
        let teamLeaderSelected = false;

        for (let i = 0; i < teams.length; i++) {
            checkedCount = teams[i].selected === true ? checkedCount + 1 : checkedCount;
            if(teams[i].is_team_leader) {
                teamLeaderSelected = true;
            }
        }
        if (name.length > 1 && checkedCount > 1 && teamLeaderSelected) {
            this.setState({
                disableSaveTeam: false,
                teams
            })
        }
        else {
            this.setState({
                disableSaveTeam: true,
                teams
            })
        }


    }

    onClickName = (event) => {
        const teams = this.state.teams;
        teams.map(
            (data, i) => {
                data.selected = event.target.checked
            }
        )
        this.onCheckSaveTeam(teams, this.state.name)
        this.setState({
            nameChecked: event.target.checked,
            teams: teams
        })
    }

    onClickUser = (event, val, type) => {
        const teams = this.state.teams;

        for (let i = 0; i < teams.length; i++) {
            if (teams[i].id === val.id && type === 'checkbox') {
                teams[i].selected = event.target.checked
                if (event.target.checked === false && teams[i].is_team_leader === true) {
                    teams[i].is_team_leader = false
                }

            }
            if (teams[i].id === val.id && type === 'radio') {
                teams[i].is_team_leader = event.target.checked
                teams[i].selected = event.target.checked
            } else if (teams[i].id !== val.id && type === 'radio') {
                teams[i].is_team_leader = false

            }
            // else {
            //     teams[i].is_team_leader = false
            // }
        }
        this.onCheckSaveTeam(teams, this.state.name)

        this.setState({
            teams: teams
        })
    }


    createNewTeam() {
        this.setState({ isCreatTrue: !this.state.isCreatTrue })
    }

    getFilterForm() {

        const personalColumn = this.state.FilterForm.map((val, pos) => ({...val, pos})).filter((val, i) => {
            return val.category === 'personal'
        })
        const workColumn = this.state.FilterForm.map((val, pos) => ({...val, pos})).filter((val, i) => {
            return val.category === 'work'
        })
        const competencyColumn = this.state.FilterForm.map((val, pos) => ({...val, pos})).filter((val, i) => {
            return val.category === 'competency'
        })
        

        const data =
            <div className="m-0 p-0" style={{ backgroundColor: 'white', color: 'black', overflowY: 'auto', maxHeight: '450px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'auto auto auto', gridGap: '1rem' }}>
                    <div>
                        <p className="font-weight-bold text-center mb-0">Personal Details</p>
                        {
                            personalColumn.map(
                                (form, i) => {
                                    return <React.Fragment key={i}>
                                        {
                                            form.heading &&
                                            <p className="font-weight-bold text-center mb-0">{form.heading}</p>
                                        }
                                        {
                                            form.subHeading &&
                                            <small style={{ display: 'block' }} className=" text-center">{form.subHeading}</small>
                                        }
                                        {
                                            (!form.heading && !form.subHeading) &&
                                            <div className="my-2 p-3" style={{ backgroundColor: "rgb(241, 241, 241)", width: "100%", padding: '5px', breakInside: 'avoid' }}>
                                                {
                                                    form.mainLabel !== '' &&
                                                    <label style={{ margin: '0px', padding: '0px 0px 5px' }}>{form.mainLabel}</label>
                                                }

                                                <div style={{}}>
                                                    {
                                                        form.type === 'text' || form.type === 'number' &&
                                                        form.data.map(
                                                            (innerForm, id) => {
                                                                return (
                                                                    <React.Fragment key={id}>
                                                                        <span> {innerForm.label} </span>
                                                                        <input onChange={(event) => this.propsChanged(event, form.pos, id, form.type)} type={form.type} value={innerForm.value} style={{ width: '45px' }} />
                                                                    </React.Fragment>
                                                                )
                                                            }
                                                        )
                                                    }

                                                    {
                                                        form.type === 'checkbox' &&
                                                        form.data.map(
                                                            (innerForm, id) => {
                                                                return (
                                                                    <React.Fragment key={id}>
                                                                        <label className="font-weight-normal cursor-pointer" style={{ display: " inline-block", paddingRight: "10px" }}>
                                                                            <input onChange={(event) => this.propsChanged(event, form.pos, id, form.type)} type="checkbox" checked={innerForm.value} />
                                                                            &nbsp;{innerForm.label}
                                                                        </label>
                                                                    </React.Fragment>
                                                                )
                                                            }
                                                        )
                                                    }

                                                    {
                                                        form.type === 'radio' &&
                                                        form.data.map(
                                                            (innerForm, id) => {
                                                                return (
                                                                    <React.Fragment key={id}>
                                                                        <label className="font-weight-normal cursor-pointer" style={{ display: " inline-block", paddingRight: "10px" }}><input onChange={(event) => this.propsChanged(event, form.pos, id, form.type)} type="radio" name={innerForm.name} checked={innerForm.value} />&nbsp;{innerForm.label}</label>
                                                                    </React.Fragment>
                                                                )
                                                            }
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        }

                                    </React.Fragment>
                                }
                            )
                        }
                    </div>
                    <div>
                        <p className="font-weight-bold text-center mb-0">Work Details</p>
                        {
                            workColumn.map(
                                (form, i) => {
                                    return <React.Fragment key={i}>
                                        {
                                            form.heading &&
                                            <p className="font-weight-bold text-center mb-0">{form.heading}</p>
                                        }
                                        {
                                            form.subHeading &&
                                            <small style={{ display: 'block' }} className=" text-center">{form.subHeading}</small>
                                        }
                                        {
                                            (!form.heading && !form.subHeading) &&
                                            <div className="my-2 p-3" style={{ backgroundColor: "rgb(241, 241, 241)", width: "100%", padding: '5px', breakInside: 'avoid' }}>
                                                {
                                                    form.mainLabel !== '' &&
                                                    <label style={{ margin: '0px', padding: '0px 0px 5px' }}>{form.mainLabel}</label>
                                                }

                                                <div style={{}}>
                                                    {
                                                        form.type === 'text' || form.type === 'number' &&
                                                        form.data.map(
                                                            (innerForm, id) => {
                                                                return (
                                                                    <React.Fragment key={id}>
                                                                        <span> {innerForm.label} </span>
                                                                        <input onChange={(event) => this.propsChanged(event, form.pos, id, form.type)} type={form.type} value={innerForm.value} style={{ width: '45px' }} />
                                                                    </React.Fragment>
                                                                )
                                                            }
                                                        )
                                                    }

                                                    {
                                                        form.type === 'checkbox' &&
                                                        form.data.map(
                                                            (innerForm, id) => {
                                                                return (
                                                                    <React.Fragment key={id}>
                                                                        <label className="font-weight-normal cursor-pointer" style={{ display: " inline-block", paddingRight: "10px" }}>
                                                                            <input onChange={(event) => this.propsChanged(event, form.pos, id, form.type)} type="checkbox" checked={innerForm.value} />
                                                                            &nbsp;{innerForm.label}
                                                                        </label>
                                                                    </React.Fragment>
                                                                )
                                                            }
                                                        )
                                                    }

                                                    {
                                                        form.type === 'radio' &&
                                                        form.data.map(
                                                            (innerForm, id) => {
                                                                return (
                                                                    <React.Fragment key={id}>
                                                                        <label className="font-weight-normal cursor-pointer" style={{ display: " inline-block", paddingRight: "10px" }}><input onChange={(event) => this.propsChanged(event, form.pos, id, form.type)} type="radio" name={innerForm.name} checked={innerForm.value} />&nbsp;{innerForm.label}</label>
                                                                    </React.Fragment>
                                                                )
                                                            }
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        }

                                    </React.Fragment>
                                }
                            )
                        }
                        {
                            !personalColumn.length && !workColumn.length && !competencyColumn.length ?
                                <p className="text-center mt-4">
                                        <i className="fas fa-spinner fa-spin " ></i>
                                        &nbsp;loading
                                </p>
                            :
                                null
                        }
                    </div>
                    <div>
                        <p className="font-weight-bold text-center mb-0">Rank by Competency</p>
                        {
                            competencyColumn.length ?
                                <div>
                                    <p className="font-weight-bold text-center mb-0 font-bold_italic_calibri-family" style={{fontSize: 14}}>(from highest to lowest)</p>
                                </div>
                            :
                                null
                        }
                        {
                            competencyColumn.map(
                                (form, i) => {
                                    return <div key={i}>
                                            <label className="font-bold_italic_calibri-family d-flex cursor-pointer" style={{ paddingRight: "10px" }}>
                                                {/* <input type="checkbox" name="choose_comp" disabled checked /> */}
                                                    <p className="mb-0 pl-1">&nbsp;Choose ONE Organizational
                                                    <br/>
                                                    Competency/Value/Metric</p>
                                            </label>
                                        {
                                            form.type === 'radio' &&
                                            form.data.map(
                                                (innerForm, id) => {
                                                    return (
                                                        <React.Fragment key={id}>
                                                            <label className="cursor-pointer font-italic-family" style={{ paddingRight: "10px", display: 'block' }}><input onChange={(event) => this.propsChanged(event, form.pos, id, form.type)} type="radio" name={innerForm.name} checked={innerForm.value} />&nbsp;{innerForm.label}</label>
                                                        </React.Fragment>
                                                    )
                                                }
                                            )
                                        }
                                        {
                                            form.type === 'checkbox' &&
                                            form.data.map(
                                                (innerForm, id) => {
                                                    return (
                                                        <React.Fragment key={id}>
                                                            <label className="cursor-pointer font-italic-family" style={{ paddingRight: "10px", display: 'block' }}><input onChange={(event) => this.propsChanged(event, form.pos, id, form.type)} type="checkbox" name={innerForm.name} checked={innerForm.value} />&nbsp;{innerForm.label}</label>
                                                        </React.Fragment>
                                                    )
                                                }
                                            )
                                        }
                                    </div>
                                }
                            )
                        }
                    </div>
                    
                </div>
            </div>

        return data
    }


    onClickResponseHandlerApply(type) {
        if(type === 'Apply Filters') {
            let FilterForm = [...this.state.FilterForm];
            let analyzeFilterData = [...this.state.analyzeFilterData.team_members];
            let analyzeFilterSkeleton = {
                age: [],
                gender: {},
                marital_status: {},
                Children_between: {},
                family_type: {},
                work_experience: {},
                occupation: {},
                Designation: {},
                Qualification: {},
                industry: {},
                Tenure: {},
                Annual_income: {
                    data: []
                },
                city: [],
                country: []
            };
            let analyzeFilterPostData = [];
            
            FilterForm.map(val => {
                if(val.data) {
                    val.data.map(value => {
                        if(value.key === "age_between" || value.key === "age_and") {
                            analyzeFilterSkeleton.age[value.key] = value.value === '' ? 0 : parseInt(value.value, 10)
                        }else if(value.key === "participant__gender"){
                            analyzeFilterSkeleton.gender[value.label] = value.value
                        }else if(value.key === "Marital status"){
                            analyzeFilterSkeleton.marital_status[value.label] = value.value
                        }else if(value.key.includes('Children_between') || value.key.includes('Children_and')){
                            analyzeFilterSkeleton.Children_between[value.key] = value.value === '' ? 0 : parseInt(value.value, 10)
                        }else if(value.key === 'Family Type') {
                            if(value.label === "Joint" || value.label === 'JointNuclear') {
                                analyzeFilterSkeleton.family_type[value.label] = value.value
                            }
                        }else if(value.key === 'city') {
                            if(value.value) {
                                analyzeFilterSkeleton["city"].push(value.label)
                            }
                        }else if(value.key === 'country') {
                            if(value.value) {
                                analyzeFilterSkeleton["country"].push(value.label)
                            }
                        }else if(value.dataFilter === "work_experience") {
                            analyzeFilterSkeleton.work_experience[value.key] = value.value === '' ? 0 : parseInt(value.value, 10)                           
                        }else if(value.key === 'occupation') {
                            analyzeFilterSkeleton.occupation[value.label] = value.value
                        }else if(value.key === 'Designation') {
                            analyzeFilterSkeleton.Designation[value.label] = value.value                            
                        }else if(value.key === 'Qualification') {
                            analyzeFilterSkeleton.Qualification[value.label] = value.value
                        }else if(value.key === 'industry') {
                            analyzeFilterSkeleton.industry[value.label] = value.value                            
                        }else if(val.mainLabel === "Tenure in company:") {
                            analyzeFilterSkeleton.Tenure[value.label] = value.value  === '' ? 0 : parseInt(value.value, 10)                           
                        }else if(value.key === "Annual income") {
                            if(value.value) {
                                analyzeFilterSkeleton.Annual_income["data"].push(value.data)
                            }
                        }
                        // else if(val.type === 'radio') {
                        //     analyzeFilterSkeleton[value.label] = value.value
                        // }
                    })
                }
            })

            let filterOptions = {
                age: [],
                marital_status: [],
                children: [],
                family_type: [],
                city: [],
                country: [],
                gender: [],
                work_experience: [],
                occupation: [],
                Designation: [],
                Qualification: [],
                industry: [],
                Tenure: [],
                annual_income: {
                    type: 'range',
                    data: []
                }
            }

            let dataToFilter = []

            analyzeFilterData.map(val => {
                let obj = {
                    age: val.age,
                    marital_status: val.marital_status,
                    children: val.no_of_children,
                    family_type: val.family_type,
                    city: val.city,
                    id: val.id,
                    country: val.participant__country__country_name,
                    gender: val.participant__gender,
                    work_experience: val.work_experience,
                    occupation: val.occupation,
                    Designation: val.designation,
                    Qualification: val.qualification__demographic_name,
                    industry: val.industry__demographic_name,
                    tenure_in_company: val.tenure_in_company,
                    annual_income: val.annual_income,
                    assessment_id: val.participant__id,
                    // created: val.assessment.created,
                    user__date_of_birth: val.participant__date_of_birth,
                    user__full_name: val.participant__email,
                    user_email: val.participant__email
                }
                dataToFilter.push(obj)
            })

            //annual
            for (let index = 0; index < analyzeFilterSkeleton.Annual_income.data.length; index++) {
                const element = analyzeFilterSkeleton.Annual_income.data[index];
                filterOptions.annual_income.data.push({
                    min: element.min,
                    max: element.max
                })                
            }

            //age
            for (let i = analyzeFilterSkeleton.age.age_between; i <= analyzeFilterSkeleton.age.age_and; i++) {
                if(i === 0 && analyzeFilterSkeleton.age.age_between === analyzeFilterSkeleton.age.age_and) {
                }else {
                    filterOptions.age.push(i)
                }
            }

            //marital_status
            for (const key in analyzeFilterSkeleton.marital_status) {
                if (analyzeFilterSkeleton.marital_status.hasOwnProperty(key)) {
                    const element = analyzeFilterSkeleton.marital_status[key];
                    if(element) {
                        filterOptions.marital_status.push(key)
                    }
                }
            }

            //no of children
            for (let i = analyzeFilterSkeleton.Children_between["No of Children_between"]; i <= analyzeFilterSkeleton.Children_between["No of Children_and"]; i++) {
                if(i === 0 && analyzeFilterSkeleton.Children_between["No of Children_between"] === analyzeFilterSkeleton.Children_between["No of Children_and"]) {
                }else {
                    filterOptions.children.push(i)
                }        
            }

            //family type
            for (const key in analyzeFilterSkeleton.family_type) {
                if (analyzeFilterSkeleton.family_type.hasOwnProperty(key)) {
                    const element = analyzeFilterSkeleton.family_type[key];
                    if(element) {
                        filterOptions.family_type.push(key)
                    }
                }
            }

            //gender
            for (const key in analyzeFilterSkeleton.gender) {
                if (analyzeFilterSkeleton.gender.hasOwnProperty(key)) {
                    const element = analyzeFilterSkeleton.gender[key];
                    if(element) {
                        filterOptions.gender.push(key)
                    }
                }
            }

            //city
            filterOptions.city = analyzeFilterSkeleton.city

            //country
            filterOptions.country = analyzeFilterSkeleton.country

            //work exp
            for (let i = analyzeFilterSkeleton.work_experience["Work Experience_between"]; i <= analyzeFilterSkeleton.work_experience["Work Experience_and"]; i++) {
                if(i === 0 && analyzeFilterSkeleton.Children_between["Work Experience_between"] === analyzeFilterSkeleton.Children_between["Work Experience_and"]) {
                }else {
                    filterOptions.work_experience.push(i)
                }
            }

            //occupation
            for (const key in analyzeFilterSkeleton.occupation) {
                if (analyzeFilterSkeleton.occupation.hasOwnProperty(key)) {
                    const element = analyzeFilterSkeleton.occupation[key];
                    if(element) {
                        filterOptions.occupation.push(key)
                    }
                }
            }
            
            //Designation
            for (const key in analyzeFilterSkeleton.Designation) {
                if (analyzeFilterSkeleton.Designation.hasOwnProperty(key)) {
                    const element = analyzeFilterSkeleton.Designation[key];
                    if(element) {
                        filterOptions.Designation.push(key)
                    }
                }
            }

            //Qualification
            for (const key in analyzeFilterSkeleton.Qualification) {
                if (analyzeFilterSkeleton.Qualification.hasOwnProperty(key)) {
                    const element = analyzeFilterSkeleton.Qualification[key];
                    if(element) {
                        filterOptions.Qualification.push(key)
                    }
                }
            }

            //industry
            for (const key in analyzeFilterSkeleton.industry) {
                if (analyzeFilterSkeleton.industry.hasOwnProperty(key)) {
                    const element = analyzeFilterSkeleton.industry[key];
                    if(element) {
                        filterOptions.industry.push(key)
                    }
                }
            }

            //tenure
            for (let i = analyzeFilterSkeleton.Tenure.Between; i <= analyzeFilterSkeleton.Tenure.and; i++) {
                if(i === 0 && analyzeFilterSkeleton.Tenure.Between === analyzeFilterSkeleton.Tenure.and) {
                }else {
                    filterOptions.Tenure.push(i)
                }
            }
        

            function range(range: any[], value: number) {
                let flag = true;
                for (let index = 0; index < range.length; index++) {
                  const el = range[index];
                  if (value >= el.min && value <= el.max) {
                    flag = true;
                    break;
                  } else {
                    // return false;
                    flag = false;
                  }
                }
                return flag ? true : false;
            }


            function multiFilter(arr, filters) {
                const array = [...arr]
                const filter = filters;
                
                array.forEach((obj) => {
                    for (const key in filter) {
                        if (obj.hasOwnProperty(key)) {
                            if(filter[key].type === 'range') {
                                if (obj[key]) obj["filtered"] = range(filter[key].data, +obj[key]);
                                else obj["filtered"] = range(filter[key].data, obj[key]);
                            }else if (filter[key].indexOf(obj[key]) != -1) {
                                obj["filtered"] = true;
                                continue;
                            } else {
                                obj["filtered"] = false;
                                break;
                            }
                        }
                    }
                });

                return array
            }

            
            

            let filterOptionsAltered = {}

            for (const key in filterOptions) {
                if (filterOptions.hasOwnProperty(key)) {
                    const element = filterOptions[key];
                    if(element.length !== 0) {
                        filterOptionsAltered[key] = element
                    }
                }
            }


            const multiFilter_filteredData = [...multiFilter(dataToFilter, filterOptionsAltered)]


            let afterAnnualIncome_filteredData = [...multiFilter_filteredData]

            this.setState({
                multiFilter_filteredData: afterAnnualIncome_filteredData
            }, () => {
                var arr = [];
                var temp = this.state.multiFilter_filteredData;
                if(Object.keys(filterOptionsAltered).length !== 0) {
                    temp.map((obj) => {
                        if(obj.filtered){
                            arr.push(obj.assessment_id)
                        }
                    })
                }else {
                    temp.map((obj) => {
                        arr.push(obj.assessment_id)
                    })
                }                
                
                
                const data_ob = {
                    team_members: [],
                } 
                this.state.multiFilter_filteredData.map((obj) => {
                    data_ob.team_members.push({
                        age: obj.age,
                        filtered: obj.filtered,
                        id: obj.id,
                        user__country__country_name: obj.country,
                        user__date_of_birth: obj.user__date_of_birth,
                        user__full_name: obj.user__full_name,
                        user_email: obj.user_email,
                        annual_income: obj.annual_income,
                        participant__gender: obj.gender,
                        city: obj.city,
                        designation: obj.Designation,
                        family_type: obj.family_type,
                        industry__demographic_name: obj.industry,
                        marital_status: obj.marital_status,
                        no_of_children: obj.children,
                        occupation: obj.occupation,
                        qualification__demographic_name: obj.Qualification,
                        tenure_in_company: obj.tenure_in_company,
                        work_experience: obj.work_experience,
                    })
                })
                
                if(this.props.callBack) {
                    this.props.callBack(data_ob)
                }
                let countOfFilteredObj = 0
                if(Object.keys(filterOptionsAltered).length !== 0) {
                    data_ob.team_members.map(val => {
                        if(val.filtered) {
                            countOfFilteredObj++
                        }
                    })
                }else {
                    countOfFilteredObj = this.state.multiFilter_filteredData.length
                }
                this.setState({
                    openFilterModal: false,
                    data_ob_filtered: data_ob,
                    analyzeFilterData: data_ob,
                    countOfFilteredObj,
                    isCreatTrue: true,
                    filterBool: true
                },() => {
                    const {dispatch} = this.props;

                    this.fillCompetencyData()

                    // function showFilteredItems() {
                    //     let stringText = ''
                    //     if(filterOptionsAltered.annual_income) {
                    //         if(filterOptionsAltered.annual_income.data.length) {
                    //             stringText = stringText + `Annual Income${Object.keys(filterOptionsAltered).length !== 1 ? ', ' : ''}`
                    //         }
                    //     }
                    //     stringText = stringText + Object.keys(filterOptionsAltered).filter(val => {
                    //         if(val !== 'annual_income') {
                    //             return val
                    //         }
                    //     }).join(', ')
                    //     return stringText
                    // }


                    // dispatch({
                    //     type: 'ADD_FILTER_FORM',
                    //     payload: [],
                    //     filter_used: true ? showFilteredItems() : `No Filters Applied`
                    // })
                })

            })

        }else if(type === 'Remove All Filters') {
            let FilterForm = [...this.state.FilterForm]
            FilterForm.map(val => {
                if(val.data) {
                    val.data.map(value => {
                        if(val.type === 'checkbox') {
                            value.value = false
                        }else if(val.type === 'number') {
                            value.value = ''
                        }else if(val.type === 'radio') {
                            value.value = false
                        }
                    })
                }
            })
            let analyzeFilterData = this.state.analyzeFilterData
            analyzeFilterData.team_members.map(val => {
                val.filtered = true
            })

            if(this.props.callBack) {
                this.props.callBack(analyzeFilterData)
            }
            this.setState({
                openFilterModal: false,                
                FilterForm,
                analyzeFilterData,
                countOfFilteredObj: this.state.analyzeFilterData.team_members.length,
                isCreatTrue: true,
                filterBool: false
                // openFilterModal: false
            },() => {
                    this.fillCompetencyData()
                // const {dispatch} = this.props;
                // // this.props.dispatch(AnalyzeAction.AnalyzeDataAction({"team_assessment_id": this.state.FilteredFormnAnalyze.team_assessment_id.length ? this.state.FilteredFormnAnalyze.team_assessment_id : assessmentIds,"relation_group_ids": assessorIds}))
                // dispatch({
                //     type: 'ADD_FILTER_FORM',
                //     payload: this.state.FilterForm,
                //     filter_used: 'Filters Removed'
                // })
            })
        }

        

        else if (type === 'Cancel') {
            this.setState({
                openFilterModal: false,
                isCreatTrue: true
            })
        }
    }

    fillCompetencyData = () => {
        let competency_id = []
        this.state.FilterForm.map(val => {
            if(val.mainLabel) {
                if(val.mainLabel === 'Rank by Competency') {
                    val.data.map(ob => {
                        if(ob.value) {
                            competency_id.push(ob.id)
                        }
                    })
                }
            }
        })
        if(competency_id.length) {
            const fdObj = {
                "assessment_id":this.state.analyzeFilterData.team_members.filter(val => val.filtered !== undefined ? val.filtered : true).map(val => val.id),
                "competency_id": competency_id
            }
            this.props.dispatch(VirtualTeamAction.filterTeamApi(fdObj, (filteredItem) => {
                this.setState({
                    sortedTeamMemberArr: filteredItem.data.sorted_assessments,
                }, () => {
                    this.setState({
                        teams: this.mapOrder(this.state.teams, this.state.sortedTeamMemberArr, 'mainId').map(team => ({...team, selected: false, is_team_leader: false}))
                    })
                })
            }))
        }else {
            this.setState({
                sortedTeamMemberArr: this.state.analyzeFilterData.team_members.filter(val => val.filtered !== undefined ? val.filtered : true).map(val => val.id)
            }, () => {
                this.setState({
                    teams: this.mapOrder(this.state.teams, this.state.sortedTeamMemberArr, 'mainId').map(team => ({...team, selected: false, is_team_leader: false}))
                })
            })
        }
    }

    propsChanged = (event, parentIdentifier, identifier, type) => {
        const updatedData = this.state.FilterForm;
        const updatedElement = updatedData[parentIdentifier].data[identifier];


        // let addingToNewArray = [...this.state.addingToNewArray]

        // if(updatedData[parentIdentifier].data[identifier].dataFilter) {

        //     this.state.analyzeFilterData.team_members.map(val => {
        //         if(val[[updatedData[parentIdentifier].data[identifier].dataFilter]]) {
        //         }else {
        //             if(val.user_details.length !== 0) {
        //                 if (type === 'checkbox' || type === 'radio') {
        //                     console.log('val_updatedData', updatedData[parentIdentifier].data[identifier].dataFilter ,val.user_details[0][updatedData[parentIdentifier].data[identifier].dataFilter], event.target.checked, updatedData[parentIdentifier].data[identifier].label)
        //                     if(event.target.checked) {
        //                         if(updatedData[parentIdentifier].data[identifier].label === val.user_details[0][updatedData[parentIdentifier].data[identifier].dataFilter]) {
        //                             addingToNewArray.push(val)
        //                         }
        //                     }else {
        //                         console.log('addingToNewArrayaddingToNewArray', addingToNewArray, val)
        //                         if(updatedData[parentIdentifier].data[identifier].label === val.user_details[0][updatedData[parentIdentifier].data[identifier].dataFilter]) {
        //                             addingToNewArray.map(value => {
        //                                 console.log('updatedData[parentIdentifier].data[identifier]', updatedData[parentIdentifier].data[identifier], value)
        //                             })
        //                         }                                
        //                     }
        //                 } else {
        //                     console.log('val_updatedData', updatedData[parentIdentifier].data[identifier].dataFilter ,val.user_details[0][updatedData[parentIdentifier].data[identifier].dataFilter], event.target.value, updatedData[parentIdentifier].data[identifier].label)                            
        //                 }
        //             }
        //         }

        //     })
        // }
        if (type === 'checkbox') {
            updatedElement.value = event.target.checked
        }else if(type === 'radio') {
            updatedData[parentIdentifier].data.map(val => {
                val.value = false
            })
            updatedElement.value = event.target.checked 
            this.setState({
                competencyTriggered: true
            })
        } else {
            updatedElement.value = event.target.value
        }

        // console.log('propsChanged', addingToNewArray)

        this.setState({ formData: updatedData });
    }

    mapOrder (array, order, key) {
  
        array.sort( function (a, b) {
          var A = a[key], B = b[key];
          
          if (order.indexOf(A) > order.indexOf(B)) {
            return 1;
          } else {
            return -1;
          }
          
        });
        
        return array;
    };
      

    render() {
        const { navData } = this.state;
        const virtualTeam = [{
            key: 'team_name',
            type: 'text',
            value: this.state.teamDetails === '' ? '' : this.state.teamDetails.team_name,
            valid: false,
            elementConfig: {
                name: 'team_name',
                label: 'Team Name',
                placeholder: 'Team Name Pvt Ltd'
            },
            validation: {
                required: true,
                message: "is required"
            },

        }]

        const { analyzeFilterData } = this.state

        return (
            <div>
                <Navbar navItems={navData} backgroundColor="black" />
                < div className="container-post-nav">
                    <SideNavBar virtualTeamFilter={true} virtualTeamState={() => {
                        this.setState({
                            openFilterModal: !this.state.openFilterModal
                        })}} sideNavItems={this.state.VirtualTeamSidebarNav.sideNavCatagoryData} organisationName={localStorage.getItem('orgName')} orgId={this.props.match.params.id} />
                    <div className="">
                        <AnalysisNavBar
                            analyticsData={this.props.saveModulePermissionsResponse}
                            orgId={this.props.match.params.id}
                            analyticsType={'people'} />
                        <div className="gradient-flex col-8" style={{padding: '6rem 0'}}>
                            <div className="px-3">
                                <h6 className="font-weight-bold font-italic text-center my-3">Create a virtual team by pulling together any combination of people reporting to you. Analyze the team by selecting it from the Team filter on the left panel of your dashboard.</h6>
                            </div>
                            <div className="d-flex flex-row justify-content-between">
                                <div className="d-flex flex-column w-100 mx-3">
                                    <div className="create-team py-2" onClick={() => this.createNewTeam()}>
                                        <p className="mb-0 text-white text-center cursor-pointer font-weight-bold" style={{fontSize: 14}}>Create New Team +</p>
                                    </div>
                                    <Collapse
                                        isOpen={this.state.isCreatTrue}
                                    >
                                        <div className="d-flex flex-column">
                                            <div className="m-1">
                                                <input
                                                    type="text" className="border p-1 w-100 teamNameInp" id="name" placeholder="Team Name *"
                                                    required
                                                    value={this.state.name}
                                                    onChange={(e) => this.setState({ name: e.target.value }, this.onCheckSaveTeam(this.state.teams, e.target.value))}
                                                />
                                            </div>
                                            {/* <div className="d-flex flex-row align-items-center border border-dark m-1 p-1">
                                                <label className="col-8 my-1 pl-0 d-flex flex-row flex-wrap justify-content-start">
                                                    <input checked={this.state.nameChecked} onChange={(event) => this.onClickName(event)} className="col-4 mt-0" type="checkbox"></input>
                                                    <span className="col-8 px-0 text-left font-weight-bold">Name</span>

                                                </label>

                                                <div className="col-4"></div>
                                            </div> */}
                                            <div className="d-flex flex-column border border-dark m-1 scroll-flex p-1">
                                                {
                                                    this.state.teams.filter((member,pos) => this.state.filterBool ? this.state.sortedTeamMemberArr.includes(member.mainId) : true ).map((val, key) => {
                                                        return (
                                                            <div key={key}>
                                                                <div className="d-flex">
                                                                    <label className="col-8 pl-0 d-flex flex-row flex-wrap justify-content-start cursor-pointer">
                                                                        <input onChange={(event) => this.onClickUser(event, val, 'checkbox')} checked={val.selected} className="col-3 mt-0" type="checkbox"></input>
                                                                        
                                                                        <span className="col-9 px-0 text-left font-italic" style={{fontSize: 12, opacity: val.selected ? '1' : '0.6', fontWeight: val.selected ? 600 : 300}}>{val.name}</span>

                                                                    </label>
                                                                    <div className="col-4" style={{padding: 0}}>
                                                                        <input style={{float: 'right', fontSize: 12}} onChange={(event) => this.onClickUser(event, val, 'radio')} checked={val.is_team_leader} className="mb-3" name="radio" type="radio" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                            <div className="d-flex flex-row align-items-center m-1">
                                                <div className="d-flex flex-row">
                                                    <label className="font-italic" style={{fontSize: 12}}><input checked className="mb-0 p-1" type="checkbox"></input>
                                                        &nbsp;Member</label>

                                                </div>
                                                <div className="d-flex flex-row ml-2">
                                                    <label className="font-italic" style={{fontSize: 12}}>
                                                        <input checked className="p-1" type="radio" />
                                                        &nbsp;Team Leader
                                                    </label>
                                                </div>
                                            </div>
                                            {/* <div className="bg bg-success" onClick={() => this.setState({ isCreatTrue: !this.state.isCreatTrue })}>
                                                <p className="mb-0 create-team p-2 text-white">Save Team</p>
                                            </div> */}
                                            <button disabled={this.state.disableSaveTeam} onClick={() => this.setState({ SaveTeamState: true })} className="btn btn-sm btn-block create-team text-white ">Save Team </button>
                                        </div> 
                                    </Collapse>
                                </div>
                                {
                                    this.state.SaveTeamState === true &&
                                    <ModalComponent
                                        showModal={this.state.SaveTeamState}
                                        heading="Add Team"
                                        htmlText={`<div className = "ml-1 ml-md-3 pl-1 pl-md-3 ">
                                             <p className="">Are you sure you want to create Virtual Team <b>${this.state.name} ?</b></span>`}
                                        footerNonSubmitButton={[{
                                            'buttonName': 'Add',
                                        }, {
                                            'buttonName': 'Cancel',
                                        }]}
                                        responseHandler={(type) => this.onClickSaveTeamHandler(type)}
                                    />
                                }
                                <div className="d-flex flex-column w-100 mx-3">
                                    <div className="d-flex flex-row">
                                        <div className="virtual-teams col-10 py-2" style={{margin: '2px 0'}}>
                                            <p className="mb-0 text-white text-center font-weight-bold" style={{fontSize: 14}}>Virtual Teams</p>
                                        </div>
                                        <div className="col-2">

                                        </div>
                                    </div>
                                    <div className="">
                                        {
                                            this.state.teamlist_data.map((val, key) => {
                                                return (
                                                    <div key={key} className="d-flex flex-row col-12 px-0">
                                                        <Link to={`/organisation/${this.props.match.params.id}/my-teams/virtual-teams/manage-members/${val.id}`} className="d-flex flex-row justify-content-between p-2 col-10 team-link" style={{margin: '2px 0'}}>
                                                            <p className="mb-0 team-name font-italic text-left" style={{fontSize: 12}}>{val.team_name}'s Team</p>
                                                            {/* <small className="mb-0 font-italic text-left">({val.member_count} members)</small> */}
                                                        </Link>
                                                        <div className="d-flex flex-row justify-content-center align-items-center col-1">
                                                            {/* <div className="p-1">
                                                                <i onClick={() => this.setState({ editTeamState: true, teamDetails: val })} className="fas fa-edit cursor-pointer"></i>
                                                            </div> */}
                                                            <div className="p-1">
                                                                <i onClick={() => this.setState({ removeTeamState: true, teamDetails: val })} className="far fa-trash-alt cursor-pointer"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                        {
                                            this.state.editTeamState &&
                                            <ModalComponent
                                                showModal={this.state.editTeamState}
                                                heading="Edit Team"
                                                formData={virtualTeam}
                                                action={this.actionSelected.bind(this)}
                                                toggleEntireModal={this.toggleEntireTeamModal.bind(this)}
                                                footerFormSubmitButton={['Save', 'Cancel']}
                                                selectKey={['parent_team_id']}
                                                selects={['parent_team_name']}
                                            />
                                        }
                                        {
                                            this.state.removeTeamState &&
                                            <ModalComponent
                                                showModal={this.state.removeTeamState}
                                                heading="Remove Team"
                                                // toggleEntireModal={this.toggleEntireTeamModal.bind(this)}
                                                htmlText={`<div className = "ml-1 ml-md-3 pl-1 pl-md-3 ">
                                                <p className="">Are you sure you want to remove the <b>${this.state.teamDetails === '' ? '' : this.state.teamDetails.team_name}'s team?</b></span>`}
                                                footerNonSubmitButton={[{
                                                    'buttonName': 'Remove',
                                                }, {
                                                    'buttonName': 'Cancel',
                                                }]}
                                                responseHandler={(type) => this.onClickResponseHandler(type)}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            analyzeFilterData.team_members.length ?
                                <Modal centered={false} isOpen={this.state.openFilterModal} fade={false} style={{ maxWidth: '800px', }}>
                                    <ModalHeader className="w-100 text-center" ><span className="h6 pb-3">Filter Team: Filtered team contains {analyzeFilterData.team_members.filter(val => val.filtered ? val.filtered : val).length} out of {analyzeFilterData.team_members.length} members.</span></ModalHeader>
                                    <ModalBody>
                                        {this.getFilterForm()}
                                        <ModalFooter style={{ margin: "auto" }} >
                                            {
                                                this.state.footerNonSubmitButton.map(
                                                    (buttonData, i) => {
                                                        return (
                                                            <Button key={i} color="primary" onClick={() => this.onClickResponseHandlerApply(buttonData.buttonName)} className="btn text-white b-0 " style={{ backgroundColor: "rgb(55, 65, 75)" }}><span className="">{buttonData.buttonName}</span></Button>
                                                        )
                                                    }
                                                )
                                            }
            
                                        </ModalFooter>
            
            
                                    </ModalBody>
            
                                </Modal>
                            :
                                null
                        }
                    </div>
                </ div>
            </div>


        );
    }
}

function mapStateToProps(state) {
    const saveModulePermissionsResponse = state.saveModulePermissionsReducer.data;
    const { getModulePermissionsLoading } = state.getModulePermissionsListReducer;
    const getModulePermissionsListError = state.getModulePermissionsListReducer.error;
    const getModulePermissionsListResponse = (!getModulePermissionsLoading && !getModulePermissionsListError) ? state.getModulePermissionsListReducer.data.data.message : '';
    const saveTeamDetailsResponse = state.saveTeamDetailsReducer.data;
         //Header Permission
         const { headPerLoading } = state.headerPermissionReducer
         const headPerLoadingError = state.headerPermissionReducer.error
         const headPerLoadingResonse = (!headPerLoading && !headPerLoadingError) ?  state.headerPermissionReducer.data : '';

         const singleValidatorResponse = state.singleValidatorReducer.data;

    const analyzeFilterData = state.saveAssesorGroupListReducer.data;  

        const {FilterForm_reducer, filter_form_updated, filter_used} = state.addFilterForm;


    return {
        saveModulePermissionsResponse,
        getModulePermissionsListResponse,
        saveTeamDetailsResponse,
        headPerLoadingResonse,
        headPerLoading,
        headPerLoadingError,

        FilterForm_reducer,
        filter_form_updated, 
        filter_used,

        analyzeFilterData,
        
        
        singleValidatorResponse
    }
}

export default connect(mapStateToProps)(ManageTeams)


// WEBPACK FOOTER //
// ./src/_pages/Organzation/Analyze/Category/VirtualTeams/ManageTeams/index.js